module.exports = __webpack_public_path__ + "static/media/slipsheet.703355f6.svg";